var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingHealthCardActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 2.58333H12.1667C13.0875 2.58333 13.8333 3.32917 13.8333 4.25V14.0661C13.8333 14.9869 13.0875 15.7328 12.1667 15.7328H2.16667C1.24583 15.7328 0.5 14.9869 0.5 14.0661V4.25C0.5 3.32917 1.24583 2.58333 2.16667 2.58333H5.5M10.0833 13.4167C9.9375 13.0508 9.7125 12.7225 9.42333 12.455C8.93417 12.0017 8.2925 12.1667 7.62583 12.1667H6.54917C5.8825 12.1667 5.24083 12.0017 4.75167 12.455C4.4625 12.7225 4.2375 13.0508 4.09167 13.4167M8.41333 6.8825C9.14557 7.61473 9.14557 8.80192 8.41333 9.53415C7.6811 10.2664 6.49392 10.2664 5.76168 9.53415C5.02945 8.80192 5.02945 7.61473 5.76168 6.8825C6.49392 6.15027 7.6811 6.15027 8.41333 6.8825ZM8 4.25H6.33333C5.87333 4.25 5.5 3.87667 5.5 3.41667V1.33333C5.5 0.873333 5.87333 0.5 6.33333 0.5H8C8.46 0.5 8.83333 0.873333 8.83333 1.33333V3.41667C8.83333 3.87667 8.46 4.25 8 4.25Z",
    stroke: "#D53E20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingHealthCardActive);
export default __webpack_public_path__ + "static/media/onboarding-health-card-active.2b3e1b97988ec8f2c8503dbefd30bfe2.svg";
export { ForwardRef as ReactComponent };